// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectSessionSwitchMessage } from '@shared/utils/DirectMessages/DirectSessionSwitchMessage';
export class SessionSwitchMessageProcessor extends MessageProcessorBase {
    decode(fs) {
        const msg = new DirectSessionSwitchMessage();
        msg.SessionId = fs.GetValue(FieldsFactory.FIELD_TRADE_SESSION_ID);
        msg.TradeSessionStatusId = fs.GetValue(FieldsFactory.FIELD_TRADE_SESSION_STATUS_ID);
        msg.ExchangeSessionName = fs.GetValue(FieldsFactory.FIELD_EXCHANGE_SESSION_NAME);
        return [msg];
    }
}
